module.exports = __webpack_public_path__ + "9f2d97a863a7a3dd85f1cc5a04e53024.fbx";